import { useQuery } from '@tanstack/react-query';
import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const fetchOverviewData = async (sessionId) => fetch(`/personnelComparisonTool/${ sessionId }/overview`).then(decodeJson)
  .catch(({ body }) => {
    throw new ApiError(
      body ? `Error: ${ body }` : 'Could not load comparison session. Either the session does not exist or it has expired. Upload a new file and try again.'
    );
  });

const useOverviewData = (sessionId) => useQuery({
  queryKey: ['personnelOverviewData', sessionId],
  queryFn: () => fetchOverviewData(sessionId),
  enabled: !!sessionId,
  staleTime: 0,
  refetchOnWindowFocus: false
})

export default useOverviewData;
